<template>
    <div>
        <Loading :isLoading="isLoading" />
        <CRow style="height:100% !important" >
            <CCol col="12" xl="12" style="height:100% !important">
                <transition name="slide">
                    <CCard style="height:100% !important">
                        <CCardBody height="100%">
                            <div class="row d-flex justify-content-end mr-0 mb-3">
                                <div class="col-auto pr-0">
                                    <CButton color="success" to="/requests/add">
                                        <CIcon :content="addIcon" /> {{ $t('button.create') }} {{ $tc('requests.title') }}
                                    </CButton>
                                </div>
                            </div>
                            <CRow>
                                <div class="col-sm-6 offset-sm-2">
                                    <CSelect 
                                        :placeholder="$t('categories.placeholder')" 
                                        :label="$t('categories.title')" 
                                        :options="categories"
                                        :value.sync="field.category_id"
                                        :plain="true"
                                    ></CSelect>
                                </div>
                                <div class="col-sm-1">
                                    <CButton color="warning" @click="onClean" class="m-2">
                                        <CIcon :content="deleteIcon" /> {{ $t('button.clean') }}
                                    </CButton>
                                </div>
                                <div class="col-sm-1">
                                    <CButton color="success" @click="onFilter" class="m-2">
                                        <CIcon :content="btnSearch" /> {{ $t('button.filter') }}
                                    </CButton>
                                </div>
                            </CRow>
                            <div v-infinite-scroll="loadMore" 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="13"
                            >
                                <CRow v-for="item of data" :key="item.id">
                                    <div class="col-sm-6 offset-sm-3">
                                        <RequestItem 
                                            :item="item" 
                                            @onShowItem="onShowItem" 
                                        />
                                    </div>
                                </CRow>
                            </div>
                        </CCardBody>  
                    </CCard>
                </transition>
            </CCol>
        </CRow>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('charges.detail')"
        >
            <div>
                <CRow>
                    <div class="col-sm-2">
                        <label class="label-detail">
                            Folio:
                        </label>
                    </div>
                    <div class="col-sm-10">
                        <label class="label-detail">
                            {{item.id}}
                        </label>
                    </div>
                </CRow>
                <CRow style="margin: 40px !important">
                    <div class="col-sm-12" style="text-align: center;">
                        <label class="label-detail">
                            {{itemUserName}}
                        </label>
                    </div>
                </CRow>
                <CRow style="margin: 40px !important">
                    <div class="col-sm-12" style="text-align: center;">
                        <label class="label-detail">
                            {{item.description}}
                        </label>
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-6 offset-sm-3">
                        <a :href="urlWhatsapp" class="btn-whatsapp" target="_blank">
                            <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                        </a>
                    </div>
                </CRow>
            </div>
            <template #footer>
                <CButton @click="showDetail = false" color="warning">Aceptar</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
import axios from 'axios'
import catalog from '../../hooks/catalogs';
import RequestItem from "./components/Item.vue";
import Loading from "../../components/Loading.vue";
import { cilPlus, cilSearch, cilTrash, cilChatBubble } from '@coreui/icons';

export default {
    name: 'Requests',
    mixins: [catalog],
    components: {
        Loading,
        RequestItem,
    },
    data() {
        return {
            page: 1,
            item: {},
            data: [],
            busy: false,
            lastPage: 1,
            field: {
                category_id: '',
            },
            categories: [],
            isLoading: true,
            addIcon: cilPlus,
            showDetail: false,
            btnSearch: cilSearch,
            deleteIcon: cilTrash,
            iconChat: cilChatBubble,
        }
    },
    methods: {
        onShowItem(item) {  
            this.item = item;
            this.showDetail = true;
        },
        onShowCloseItem() {  
            this.item = {};
            this.showDetail = false;
        },
        onClean() {  
            this.field = {
                category_id: '',
            };

            this.page = 1;
            this.data = [];
            this.lastPage = 1;
            this.isLoading = true;
            this.onGetRecords();
        },
        onFilter() {  
            this.page = 1;
            this.data = [];
            this.lastPage = 1;
            this.isLoading = true;
            this.onGetRecords();
        },
        loadMore() {  
            let self = this;

            if (self.lastPage > self.page) {
                self.page++;
                self.busy = true;
                self.isLoading = true;
                self.onGetRecords();
            }
        },
        onGetRecords() {  
            let self = this;
            const token = localStorage.getItem('token', null);

            var url = `requests?page=${this.page}&category_id=${this.field.category_id}`;

            if (self.field.type_id == "1") {
                url = url + `&isPremium=1`;
            }

            axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                })
                .then(response => {
                    self.lastPage = response.data.last_page;
                    self.data.push(...response.data.data);
                    self.busy = false;
                    self.isLoading = false;
                }).catch(error => {
                    if (error.response.status === 401) {
                        self.$router.push({ path: '/login' });
                    } else {
                        self.$toast.error(error.response.data.message);
                    }
                });
        },
    },
    computed: {
        itemUserName() {
            return this.item.user != null ? this.item.user.name : "";
        },
        urlWhatsapp() {
            return "https://wa.me/"+this.item.phone;
        },
    },
    mounted() {
        let self = this;

        axios.get(`categories`)
            .then(response => {
                response.data.forEach(function(record){
                    self.categories.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        self.onGetRecords();
    }
}
</script>

<style>
    .label {
        color: white;
        font-size: 20px;
    }
    .label-detail {
        color: black;
        font-size: 20px;
    }
    .btn-detail {
        height: 50px; 
        padding: 10px;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        text-align: center; 
        border-radius: 25px; 
        background-color: grey; 
        color: white !important; 
        border: 2px solid white; 
    }
    .btn-whatsapp {
        height: 50px; 
        padding: 20px;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        text-align: center; 
        border-radius: 25px; 
        background-color: grey; 
        color: white !important; 
        border: 2px solid white; 
    }
</style>
